// Socket connection status
export const SOCKET_CONNECTING = 'connecting';
export const SOCKET_CONNECTED = 'connected';
export const SOCKET_DISCONNECTED = 'disconnected';
export const SOCKET_UNESTABLISHED = 'unestablished';
